"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldViewDisplay = void 0;
const react_1 = __importDefault(require("react"));
const EMPTY_MARK = '—';
function isEmpty(v) {
    if (v === undefined || v === null || v === '')
        return true;
    if (Array.isArray(v) && v.length === 0)
        return true;
    return false;
}
function formatDate(v) {
    const s = String(v).trim();
    const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(s);
    if (!m)
        return s;
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const monthIdx = parseInt(m[2], 10) - 1;
    return `${m[3]} ${months[monthIdx] ?? m[2]} ${m[1]}`;
}
function resolveLookupLabel(v, options) {
    if (!options || options.length === 0)
        return String(v);
    const match = options.find((o) => String(o.value) === String(v));
    return match ? String(match.label) : String(v);
}
function getOptions(field, lookups) {
    if (field.options && field.options.length > 0)
        return field.options;
    if (field.lookup && lookups?.[field.lookup])
        return lookups[field.lookup];
    return [];
}
const FieldViewDisplay = ({ field, value, siblingData, lookups }) => {
    let display = EMPTY_MARK;
    if (!isEmpty(value)) {
        switch (field.type) {
            case 'date':
                display = formatDate(value);
                break;
            case 'select':
            case 'radio':
                display = resolveLookupLabel(value, getOptions(field, lookups));
                break;
            case 'checkbox':
                display = value ? 'Yes' : 'No';
                break;
            case 'phone': {
                const cc = field.countryCodeKey && siblingData?.[field.countryCodeKey];
                display = cc ? `+${cc} ${value}` : String(value);
                break;
            }
            case 'file': {
                if (typeof value === 'string' && value.startsWith('http')) {
                    display = react_1.default.createElement("a", { href: value, target: "_blank", rel: "noopener noreferrer" }, "View file");
                }
                else if (value && typeof value === 'object' && value.url) {
                    display = react_1.default.createElement("a", { href: value.url, target: "_blank", rel: "noopener noreferrer" }, "View file");
                }
                else {
                    display = 'Uploaded';
                }
                break;
            }
            case 'image': {
                const src = typeof value === 'string' ? value : value?.url;
                display = src ? (react_1.default.createElement("img", { src: src, alt: field.label, className: "wf-view-image" })) : ('Uploaded');
                break;
            }
            default:
                display = String(value);
        }
    }
    return (react_1.default.createElement("div", { className: "field-group wf-view-field" },
        react_1.default.createElement("label", { className: "field-label" }, field.label),
        react_1.default.createElement("div", { className: `wf-view-value${isEmpty(value) ? ' wf-view-empty' : ''}` }, display)));
};
exports.FieldViewDisplay = FieldViewDisplay;
